import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as clientsActions from '../../actions/clients';



function mapStateToProps(state) {
    return {clientsState : state.clients }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(clientsActions, dispatch);
}

class Clients extends React.Component {

    render() {
        return React.cloneElement(this.props.children, this.props);        
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Clients);


/** WEBPACK FOOTER **
 ** ./src/components/containers/Clients.jsx
 **/